export const SEARCH_PREVIEW_IMAGE = 'search-preview-image';
export const SEARCH_PREVIEW_IMAGE_PLACEHOLDER = 'search-preview-image-placeholder';
export const SEARCH_PREVIEW_IMAGE_SIZE = 80;
export const SEARCH_PREVIEW_IMAGE_WRAPPER_HEIGHT = 110;
